module.exports = {
    sign: 'yypt', // 数据标识，（系统名，如property为物业云的英文首字母）用来标识顶部导航栏
    router: 'yypt', // 路径，这个路径是指路由路径，也指代码在服务器的存放路径
    tokenSign: 'operate', // 用来区分是运营前台还是后台,暂时只有两个值，一个是operate（运营前台） 另一个为backstage（后台），这个标识常用于存储token、用户信息。因为只有这两个值在同平台不同系统都是相同的
    api: 'http://kfpt.umeetech.com',
    name: 'zckjyypt', // 数据标识2
    systemName: '致程标准运营平台', // 系统名
    nameCN: '运营平台', // 平台中文名
    // port: 8898 // 端口号，这个端口号尽量每个系统都不同，方便同时开启多个系统，运营系统为88开头，后台为77开头，同一个系统端口后两位相同，如物业云前台为8888，则物业云后台为7788
}